const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#b12a1c',
                hover: '#94080d'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
